import List from '@utils/list'
const { Search, Table } = List

const search = new Search('inventoryCollaboration.supstockreport')
  .placeholder('searchPlaceholder')
  .add('officeNo').prop('supOfficeNo').select('/sysOffice/getSysOfficeByParams')
  .add('reportNo')
  .add('purchaseNo')

const table = new Table('inventoryCollaboration.supstockreport')
  .type('index')
  .add('supOfficeName')
  .add('purchaseDate')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('stockQty')
  .add('reportNo').width(160)
  .add('purchaseNo')
  .add('editionNo')
  .add('adddate').width(160)

export default new List()
  .url('/srmProductionReportHead/getStockCountPage', process.env.VUE_APP_PURCHASE_API)
  .search(search)
  .table(table)
  .end()
